'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.READ_BUTTON_CLICKED = exports.CLOSE_COOKIE_MODAL = undefined;

var _doctifyUtils = require('doctify-utils');

var CLOSE_COOKIE_MODAL = exports.CLOSE_COOKIE_MODAL = 'COOKIE_MODAL:CLOSE_COOKIE_MODAL';

var READ_BUTTON_CLICKED = exports.READ_BUTTON_CLICKED = 'COOKIE_MODAL:READ_BUTTON_CLICKED';

var CookieModalActions = {
    closeCookieModal: function closeCookieModal() {
        return {
            type: CLOSE_COOKIE_MODAL
        };
    },
    readButtonClicked: function readButtonClicked() {
        return {
            type: READ_BUTTON_CLICKED
        };
    }
};

exports.default = CookieModalActions;


//////////////////
// WEBPACK FOOTER
// ./node_modules/doctify-global-redux/lib/actions/cookie-modal.js
// module id = 654
// module chunks = 0